<template>
  <div id="app">
    <div v-if="showModalAddBillImages">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thay đổi file PDF</h5>
                  <button
                    type="button"
                    @click="closeAddPhuLuc()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="form-group row img-list mr-0 ml-0">
                    <ul>
                      <li v-for="(itemPdf, index) in imageData" :key="index">
                        <a class="overflow-scroll" data-toggle="modal">
                          <a :href="itemPdf.dataURL" target="_blank" class="font-size-12">
                            {{ itemPdf.dataURL ? getNamePDF(itemPdf.dataURL) : itemPdf.name }}
                          </a>
                          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                        </a>
                      </li>
                      <!-- <li>
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input
                            @input="onSelectFile"
                            ref="fileInput"
                            type="file"
                          />
                        </div>
                      </li> -->
                      <li v-if="imageData.length < 1">
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input
                            id="filePDF"
                            @input="onSelectFile($event, imageData)"
                            ref="fileInput"
                            type="file"
                            accept=".pdf,.doc"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" @click="closeAddPhuLuc()" class="btn btn-light">
                    Đóng
                  </button>
                  <button
                    @click="submitAdd()"
                    type="button"
                    class="btn btn-primary"
                    :disabled="imageData.length === 0 || changePDF === false"
                  >
                    Cập nhật
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div id="app">
      <div v-if="showModalErr">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="showModalErr = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ messErr }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="showModalErr = false"
                      data-dismiss="modal"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="showLoading">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Thông báo</h5>
                </div>
                <div class="modal-body text-center">
                  <div class="box-loading d-flex justify-content-center">
                    <div class="loading f20 py-2">
                      <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
                    </div>
                  </div>
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    props: ['showModalAddBillImages', 'dataImagesContract', 'dataContract', 'generalImages'],

    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        formData2: new FormData(),
        arrayImgInsertSuccess: [],
        imageData: [],
        showModalErr: false,
        messErr: '',
        PDFInsertSuccess: '',
        showLoading: false,
        changePDF: false,
        generalImagesUpload: [],
      }
    },

    updated() {
      this.imageData = this.dataImagesContract
    },

    methods: {
      async onSelectFile(event, filePDF) {
        const fup = document.getElementById('filePDF')
        const fileName = fup.value
        const ext = fileName.substring(fileName.lastIndexOf('.') + 1)
        if (ext !== 'pdf') {
          alert('Định dạng ảnh không đúng')
          return
        }

        const files = event.target.files
        const FileSize = files[0].size / 1024 / 1024 // in MB

        if (FileSize > 25) {
          alert('File quá lớn. Vui lòng thử lại')
          return
        }
        if (filePDF.length >= 1) {
          alert('Chỉ được up tối đa 1 file')
          return
        }
        if (files && files[0]) {
          this.imageData.push(files[0])
        }

        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'PDF') // NextCrm
        // this.arrayFormData.push(this.formData2)
        this.changePDF = true
      },

      async uploadPDF() {
        try {
          await ContractService.uploadFileS3PDF(this.formData2).then(res => {
            if (res.code === 1000) {
              this.PDFInsertSuccess = res.data[0]
              this.savePDF()
            }
          })
        } catch (error) {
          console.log(error)
        } finally {
        }
      },

      async savePDF() {
        try {
          this.transformImage()
          if (this.PDFInsertSuccess !== '') {
            this.generalImagesUpload.push({
              contractS3URL: this.PDFInsertSuccess,
              accessKey: '',
              dataType: 'PDF',
            })
            const body = {
              contractId: this.dataContract.id,
              customerId: this.dataContract.customerId,
              deviceType: 'WEB',
              images: this.generalImagesUpload,
              stores: this.dataContract.stores,
            }
            const response = await ContractService.saveMixFiles(body)
            if (response.result === true || response.success === true) {
              this.$emit('successImg', 2)
            } else {
              this.$emit('errorImg', response.message)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
        }
      },

      transformImage() {
        this.generalImagesUpload = this.generalImages.map(e => {
          return {
            accessKey: e.accessKey,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
        this.dataContract.stores = this.dataContract.stores.map(e => {
          return {
            accessKey: e.accessKey,
            areaAddress: e.areaAddress,
            areaId: e.areaId,
            areaName: e.areaName,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
      },

      async closeAddPhuLuc() {
        this.imageData = []
        this.PDFInsertSuccess = ''
        this.changePDF = false
        this.$emit('close')
      },

      async submitAdd() {
        try {
          this.showLoading = true
          this.messErr = 'Đang cập nhật file PDF, vui lòng chờ !'
          await this.uploadPDF()
          await this.$emit('submitAddBillImages', { dataImages: this.imageData })
          this.showLoading = false
          this.closeAddPhuLuc()
          // this.$emit('close')
        } catch (error) {
          console.log(error)
        }
      },

      removeImg(index) {
        this.generalImages.map((e, i) => {
          if (this.imageData[index].accessKey === e.accessKey) {
            this.generalImages.splice(i, 1)
          }
        })

        this.imageData.splice(index, 1)
        if (this.dataContract.imageStatus === 'FULL_IMAGE' && this.imageData.length < 1) {
          this.showModalErr = true
          this.messErr = 'Bạn phải upload một file PDF'
        }
      },

      getNamePDF(url) {
        const uri_dec = decodeURIComponent(url)
        if (uri_dec.includes('PDF')) {
          const start = uri_dec.indexOf('PDF/')
          return uri_dec.substring(start + 4)
        }
        if (uri_dec.includes('file')) {
          const start = uri_dec.indexOf('file/')
          return uri_dec.substring(start + 5)
        }
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    margin-top: 0;
  }
</style>
